import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';

import { getRenderElement } from '../../../../slatePlugins/common/utils/getRenderElement';
import { setDefaults } from '../../../../slatePlugins/common/utils/setDefaults';
import { SPECIAL_OBJECT_VOID } from './types';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const SpecialObjectElement = dynamicEditorComponent(() =>
  import('./SpecialObjectElement').then((mod) => mod.SpecialObjectElement),
);
const UserSpecialObjectElement = withDynamicBlogEditorPluginHydration()(dynamicEditorComponent(() =>
  import('./UserSpecialObjectElement').then((mod) => mod.UserSpecialObjectElement),
));

export const renderElementSpecialObjectVoid = (options?: any) => {
  const { isReadOnly } = options;
  const { specialObjectVoid } = setDefaults(options, {
    specialObjectVoid: {
      type: SPECIAL_OBJECT_VOID,
      component: isReadOnly ? UserSpecialObjectElement : SpecialObjectElement,
    },
  });

  return getRenderElement(specialObjectVoid);
};
